// extracted by mini-css-extract-plugin
module.exports = {"hidden":"chatDetail_hidden__zlG5_","textEmphasis":"chatDetail_textEmphasis___cKBc","detailArea":"chatDetail_detailArea__H7UBl"};